import { render, staticRenderFns } from "./show.html?vue&type=template&id=328b5b00&scoped=true&"
import script from "./ShowSchool.vue?vue&type=script&lang=js&"
export * from "./ShowSchool.vue?vue&type=script&lang=js&"
import style0 from "./ShowSchool.vue?vue&type=style&index=0&id=328b5b00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328b5b00",
  null
  
)

export default component.exports